//maybe this is StarFilledIcon
import React from 'react'
import {Icon} from '@chakra-ui/react'

const StarIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M20.4999 3L25.8488 13.1379L37.1434 15.0922L29.1545 23.3121L30.7862 34.6578L20.4999 29.6L10.2137 34.6578L11.8453 23.3121L3.85645 15.0922L15.1511 13.1379L20.4999 3Z"
                fill="#76B82A"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5 1.5C21.0563 1.5 21.567 1.80796 21.8266 2.30004L26.8313 11.7857L37.3992 13.6142C37.9474 13.709 38.3981 14.0995 38.57 14.6287C38.742 15.1578 38.6069 15.7387 38.2191 16.1376L30.7443 23.8286L32.2709 34.4443C32.3501 34.995 32.118 35.5443 31.6679 35.8713C31.2178 36.1984 30.6236 36.2494 30.1243 36.0039L20.5 31.2715L10.8756 36.0039C10.3763 36.2494 9.78217 36.1984 9.33205 35.8713C8.88194 35.5443 8.64981 34.995 8.729 34.4443L10.2556 23.8286L2.78082 16.1376C2.39305 15.7387 2.25797 15.1578 2.4299 14.6287C2.60183 14.0995 3.05251 13.709 3.60074 13.6142L14.1686 11.7857L19.1733 2.30004C19.4329 1.80796 19.9436 1.5 20.5 1.5ZM20.5 6.21447L16.4778 13.8379C16.2608 14.2493 15.8652 14.5367 15.4069 14.616L6.91362 16.0855L12.921 22.2666C13.2452 22.6002 13.3963 23.0652 13.3301 23.5256L12.1031 32.0572L19.8381 28.2539C20.2555 28.0487 20.7445 28.0487 21.1618 28.2539L28.8968 32.0572L27.6699 23.5256C27.6037 23.0652 27.7548 22.6002 28.0789 22.2666L34.0863 16.0855L25.5931 14.616C25.1348 14.5367 24.7392 14.2493 24.5221 13.8379L20.5 6.21447Z"
                fill="#76B82A"
            />
        </Icon>
    )
}

export default StarIcon
